module.exports = __webpack_public_path__ + "img/rcyyb.ae37b854.png";